export default IconClockX => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-clock-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M20.926 13.15a9 9 0 1 0 -7.835 7.784" />
  <path d="M12 7v5l2 2" />
  <path d="M22 22l-5 -5" />
  <path d="M17 22l5 -5" />
</svg>`;